module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "content"
  }, _vm._l((_vm.categories), function(category, $index) {
    return _c('li', [_c('div', {
      staticClass: "setting bb"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('toggle-button', {
      staticClass: "toggleButton",
      attrs: {
        "color": "#3cf",
        "sync": true
      },
      on: {
        "change": function($event) {
          _vm.toggleCategory($event, category.id, $index)
        }
      },
      model: {
        value: (category.enabled),
        callback: function($$v) {
          category.enabled = $$v
        },
        expression: "category.enabled"
      }
    }), _vm._v(" "), (!category.open) ? _c('i', {
      staticClass: "fa fa-plus",
      on: {
        "click": function($event) {
          category.open = true
        }
      }
    }) : _c('i', {
      staticClass: "fa fa-minus",
      on: {
        "click": function($event) {
          category.open = false
        }
      }
    })], 1), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (category.open),
        expression: "category.open"
      }],
      staticClass: "indent"
    }, _vm._l((category.bulletin_events), function(event) {
      return _c('li', [_c('div', {
        staticClass: "category-title"
      }, [_vm._v(_vm._s(_vm._f("deCamelCase")(event.name)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.description))]), _vm._v(" "), _c('div', {
        staticClass: "setting"
      }, [_c('toggle-button', {
        staticClass: "toggleButton no-margin",
        attrs: {
          "color": "#3cf",
          "sync": true
        },
        on: {
          "change": function($event) {
            _vm.changeSettings([event.id], ['enabled'], $event.value)
          }
        },
        model: {
          value: (event.enabled),
          callback: function($$v) {
            event.enabled = $$v
          },
          expression: "event.enabled"
        }
      }), _vm._v("\n          Receive Portal Notifications\n        ")], 1), _vm._v(" "), _c('div', {
        staticClass: "setting"
      }, [_c('toggle-button', {
        staticClass: "toggleButton no-margin",
        attrs: {
          "color": "#3cf",
          "sync": true
        },
        on: {
          "change": function($event) {
            _vm.changeSettings([event.id], ['email'], $event.value)
          }
        },
        model: {
          value: (event.email),
          callback: function($$v) {
            event.email = $$v
          },
          expression: "event.email"
        }
      }), _vm._v("\n          Receive Email Notifications\n        ")], 1), _vm._v(" "), _c('div', {
        staticClass: "setting"
      }, [_c('toggle-button', {
        staticClass: "toggleButton no-margin",
        attrs: {
          "color": "#3cf",
          "sync": true
        },
        on: {
          "change": function($event) {
            _vm.changeSettings([event.id], ['push'], $event.value)
          }
        },
        model: {
          value: (event.push),
          callback: function($$v) {
            event.push = $$v
          },
          expression: "event.push"
        }
      }), _vm._v("\n          Receive Push Notifications\n        ")], 1)])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ba3cb18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/BulletinSettings.vue
// module id = 2085
// module chunks = 2